import { FallbackComponentProps } from "./ErrorBoundary";

// Define the FallbackComponent
const ErrorFallbackComponent: React.FC<FallbackComponentProps> = ({
  error,
  errorInfo,
  onReset,
}) => (
  <div>
    <h1>Oops! Something went wrong.</h1>
    <p>{error.toString()}</p>
    <pre>{errorInfo?.componentStack ?? ""}</pre>
    <button onClick={onReset}>Try Again</button>
  </div>
);

export default ErrorFallbackComponent;
